import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseLoginComponent } from './login.component';
import { TranslateModule } from '../../../../../node_modules/@ngx-translate/core';

const routes = [
    {
        path     : 'login',
        component: FuseLoginComponent
    }
];

@NgModule({
    declarations: [
        FuseLoginComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    providers: [
    ]
})

export class LoginModule
{

}



// WEBPACK FOOTER //
// ./src/app/main/content/login/login.module.ts